let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("joESl")).then(() => parcelRequire('k1Lui'));